<template>
  <b-card>
    <groupe-form v-if="groupe" :initial-groupe="groupe"/>
  </b-card>
</template>

<script>
import GroupeForm from "@/components/GroupeForm";

export default {
  name: "GroupeEdit",
  components: {GroupeForm},
  data() {
    return {
      groupe: false
    }
  },
  mounted() {
    let _this = this;
    this.$store.dispatch('groupeModule/fetch', {
      groupe_id: this.$route.params.id
    }).then(function (response) {
      _this.groupe = response.data;
    })
  }
}
</script>

<style scoped>
</style>
